module.exports = __webpack_public_path__ + "media/images/jero-macbook-3294a5a5589f682f7f8334e189c4b7ab.webp";